import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import SideNavBar from '../../components/SideNavBar/SideNavBar';
import RegistrationMessage from '../RegistrationMessage/RegistrationMessage';
import RejectionMessage from '../RejectionMessage/RejectionMessage';
// import './recruitmentform.css';

function RecruitmentMessage() {
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Recruitment Settings', isActive: true, path: '/admin/recuritementmessage' },
        { title: 'Messages', isActive: false, path: '' },
    ];

    const [activeTab, setActiveTab] = React.useState('registration');
    const [editRegistrationMessage, setEditRegistrationMessage] = React.useState('');
    const [updateRegistrationData, setUpdateRegistrationData] = React.useState('');
    const [hideContainer, setHideContainer] = React.useState(true);

    const updateRegistrationDetails = (data) => {
        setUpdateRegistrationData(data);
        setEditRegistrationMessage('');
    };

    const getEditData = (data) => {
        setEditRegistrationMessage(data);
        setHideContainer(false);
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            {hideContainer == false ? (
                <SideNavBar
                    form={'registrationMessage'}
                    messageType={activeTab}
                    editData={editRegistrationMessage}
                    handleData={(data) => {
                        updateRegistrationDetails(data);
                    }}
                    hideContainer={hideContainer}
                    setHideContainer={() => setHideContainer()}
                />
            ) : null}
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <div className="col-md-12 d-flex align-items-center border-bottom ">
                            {/*Tab Structure Starts Here*/}
                            <ul className="nav nav-pills " id="pills-tab" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className="nav-link rounded-0 font-14 bold-text active tab-style  me-4 px-0 mx-0 "
                                        id="all_leave_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#all_leave_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="all_leave_request"
                                        aria-selected="true"
                                        onClick={() => {
                                            setActiveTab('registration');
                                        }}
                                    >
                                        Registration Messages
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className="nav-link rounded-0 font-14 bold-text tab-style me-4 px-0 mx-0 "
                                        id="my_leave_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#my_leave_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="my_leave_request"
                                        aria-selected="false"
                                        onClick={() => {
                                            setActiveTab('rejection');
                                        }}
                                    >
                                        Rejection Messages
                                    </button>
                                </li>
                            </ul>
                            {/*Tab Structure Ends Here*/}
                            <div className="ms-auto d-flex">
                                <button className="btn hive-btn-primary" onClick={() => setHideContainer(false)}>
                                    <img src="/Images/plus.svg" className="me-2" />
                                    New Message
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="tab-content" id="pills-tabContent">
                        <RegistrationMessage
                            editData={(data) => {
                                getEditData(data);
                            }}
                            updateData={updateRegistrationData}
                        />
                        <RejectionMessage
                            editData={(data) => {
                                getEditData(data);
                            }}
                            updateData={updateRegistrationData}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RecruitmentMessage;
